"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_FEUD: function() {
        return ADD_FEUD;
    },
    COMPLETE_FEUD: function() {
        return COMPLETE_FEUD;
    },
    DELETE_FEUD: function() {
        return DELETE_FEUD;
    },
    DUPLICATE_FEUD: function() {
        return DUPLICATE_FEUD;
    },
    GENERATE_FEUDS: function() {
        return GENERATE_FEUDS;
    },
    NEXT_STAGE: function() {
        return NEXT_STAGE;
    },
    PREVIOUS_STAGE: function() {
        return PREVIOUS_STAGE;
    },
    PRODUCTION_COMPLETE_FEUDS: function() {
        return PRODUCTION_COMPLETE_FEUDS;
    },
    RESET_FEUDS: function() {
        return RESET_FEUDS;
    },
    RESET_STAGE: function() {
        return RESET_STAGE;
    },
    UPDATE_FEUD: function() {
        return UPDATE_FEUD;
    }
});
const ADD_FEUD = "ADD_FEUD";
const UPDATE_FEUD = "UPDATE_FEUD";
const DELETE_FEUD = "DELETE_FEUD";
const GENERATE_FEUDS = "GENERATE_FEUDS";
const RESET_FEUDS = "RESET_FEUDS";
const DUPLICATE_FEUD = "DUPLICATE_FEUD";
const PRODUCTION_COMPLETE_FEUDS = "PRODUCTION_COMPLETE_FEUDS";
const NEXT_STAGE = "NEXT_STAGE";
const PREVIOUS_STAGE = "PREVIOUS_STAGE";
const RESET_STAGE = "RESET_STAGE";
const COMPLETE_FEUD = "COMPLETE_FEUD";
